import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './TournamentDraws.css';
import bishopGamesLogo from '../img/bishop_games_logo.png';
// ✅ Import sponsor logos
// ✅ Import ALL sponsor logos
import twpLogo from '../img/twp_logo.jpeg';
import lifelensLogo from '../img/lifelens_logo.jpeg';
import chakrumLogo from '../img/chakrum_logo.jpeg';
import aadicuraLogo from '../img/aadicura_logo.svg';
import ashtamLogo from '../img/ashtam_tech_logo.png';
import yellow360Logo from '../img/yellow_360_logo.png';
import nnLogo from '../img/nadiad_nexus_logo.png';
import kewalLogo from '../img/kewal_prints_logo.png';
import jiyasLogo from '../img/jiyas_logo.png';
import saiFinLogo from '../img/sai_logo.png';
import irishkaLogo from '../img/irishka_logo.jpg';

const TournamentDraws = () => {
  const { tournamentId, sportId } = useParams();
  const navigate = useNavigate();
  
  const [tournament, setTournament] = useState(null);
  const [sport, setSport] = useState(null);
  const [groups, setGroups] = useState([]);
  const [roundRobinMatches, setRoundRobinMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeView, setActiveView] = useState('groups');

  // ✅ SPORT DATA WITH SPONSORS
  const getSportData = (sportIdParam) => {
    const sportDataMap = {
      'badminton': {
        sportName: 'Badminton',
        matchDate: '21-12-2025',
        coordinator: 'Mr. Kalpesh Randeria - BNI Apricus/ Mr. Sunil Patel - BNI Albus',
        sponsor: {
          name: 'Ms. Purabi Prajapati',
          company: "Jiya's Designer Studio",
          logo: jiyasLogo,
          chapter: 'BNI Kinesis'
        },
        groups: [
          {
            groupName: 'Group A',
            color: '#e8d5fd',
            teams: [
              { position: 'A1', name: 'Kinesis' },
              { position: 'A2', name: 'Apricus' },
              { position: 'A3', name: 'Asilo' },
              { position: 'A4', name: 'Apollo' }
            ]
          },
          {
            groupName: 'Group B',
            color: '#d5c5f0',
            teams: [
              { position: 'B1', name: 'Vesta' },
              { position: 'B2', name: 'Egan' },
              { position: 'B3', name: 'Aphrodite' }
            ]
          },
          {
            groupName: 'Group C',
            color: '#c9b3e6',
            teams: [
              { position: 'C1', name: 'Eos' },
              { position: 'C2', name: 'Vulcan' },
              { position: 'C3', name: 'Midas' }
            ]
          },
          {
            groupName: 'Group D',
            color: '#b8a0db',
            teams: [
              { position: 'D1', name: 'Alexious' },
              { position: 'D2', name: 'Albus' },
              { position: 'D3', name: 'Venus' }
            ]
          }
        ],
        roundRobinMatches: [
          {
            groupName: 'Group A',
            matches: [
              { matchNumber: 1, team1: 'Kinesis', team2: 'Apricus', time: '1:00 PM', date: '21-12-2025' },
              { matchNumber: 2, team1: 'Asilo', team2: 'Apollo', time: '1:00 PM', date: '21-12-2025' },
              { matchNumber: 6, team1: 'Kinesis', team2: 'Asilo', time: '1:30 PM', date: '21-12-2025' },
              { matchNumber: 7, team1: 'Apricus', team2: 'Apollo', time: '1:30 PM', date: '21-12-2025' }
            ]
          },
          {
            groupName: 'Group B',
            matches: [
              { matchNumber: 3, team1: 'Vesta', team2: 'Egan', time: '1:00 PM', date: '21-12-2025' },
              { matchNumber: 8, team1: 'Egan', team2: 'Aphrodite', time: '1:30 PM', date: '21-12-2025' },
              { matchNumber: 11, team1: 'Vesta', team2: 'Aphrodite', time: '2:00 PM', date: '21-12-2025' }
            ]
          },
          {
            groupName: 'Group C',
            matches: [
              { matchNumber: 4, team1: 'Eos', team2: 'Vulcan', time: '1:00 PM', date: '21-12-2025' },
              { matchNumber: 9, team1: 'Vulcan', team2: 'Midas', time: '2:00 PM', date: '21-12-2025' },
              { matchNumber: 12, team1: 'Eos', team2: 'Midas', time: '2:00 PM', date: '21-12-2025' }
            ]
          },
          {
            groupName: 'Group D',
            matches: [
              { matchNumber: 5, team1: 'Alexious', team2: 'Albus', time: '1:30 PM', date: '21-12-2025' },
              { matchNumber: 10, team1: 'Albus', team2: 'Venus', time: '2:00 PM', date: '21-12-2025' },
              { matchNumber: 13, team1: 'Alexious', team2: 'Venus', time: '2:30 PM', date: '21-12-2025' }
            ]
          }
        ],
        knockoutMatches: [
          { stage: 'Semi Final 1', match: 'Group A vs Group D', time: '3:30 PM', date: '21-12-2025', matchNumber: 14 },
          { stage: 'Semi Final 2', match: 'Group B vs Group C', time: '4:00 PM', date: '21-12-2025', matchNumber: 15 },
          { stage: 'Third Place', match: 'Loser SF1 vs Loser SF2', time: '5:00 PM', date: '21-12-2025', matchNumber: 16 },
          { stage: 'Finals', match: 'Winner SF1 vs Winner SF2', time: '5:30 PM', date: '21-12-2025', matchNumber: 17 }
        ]
      },
      
      'box-cricket': {
        sportName: 'Box Cricket',
        matchDate: '20-12-2025',
        coordinator: 'Mr. Pranav Kothari - BNI Venus/ Mr. Shivam Gandhi - BNI Midas',
        sponsor: {
          name: 'Mr. Jeet Patel',
          company: "Nadiad Nexus",
          logo: nnLogo,
          chapter: 'BNI Kinesis'
        },
        groups: [
          {
            groupName: 'Group A',
            color: '#e8d5fd',
            teams: [
              { position: 'A1', name: 'Egan' },
              { position: 'A2', name: 'Vesta' },
              { position: 'A3', name: 'Albus' },
              { position: 'A4', name: 'Vulcan' }
            ]
          },
          {
            groupName: 'Group B',
            color: '#d5c5f0',
            teams: [
              { position: 'B1', name: 'Apollo' },
              { position: 'B2', name: 'Eos' },
              { position: 'B3', name: 'Apricus' }
            ]
          },
          {
            groupName: 'Group C',
            color: '#c9b3e6',
            teams: [
              { position: 'C1', name: 'Kinesis' },
              { position: 'C2', name: 'Midas' },
              { position: 'C3', name: 'Aphrodite' }
            ]
          },
          {
            groupName: 'Group D',
            color: '#b8a0db',
            teams: [
              { position: 'D1', name: 'Venus' },
              { position: 'D2', name: 'Asilo' },
              { position: 'D3', name: 'Alexious' }
            ]
          }
        ],
        roundRobinMatches: [
          {
            groupName: 'Group A',
            matches: [
              { matchNumber: 1, team1: 'Egan', team2: 'Vesta', time: '4:00 PM', date: '20-12-2025' },
              { matchNumber: 2, team1: 'Albus', team2: 'Vulcan', time: '4:00 PM', date: '20-12-2025' },
              { matchNumber: 6, team1: 'Egan', team2: 'Albus', time: '5:00 PM', date: '20-12-2025' },
              { matchNumber: 7, team1: 'Vesta', team2: 'Vulcan', time: '5:30 PM', date: '20-12-2025' }
            ]
          },
          {
            groupName: 'Group B',
            matches: [
              { matchNumber: 3, team1: 'Apollo', team2: 'Eos', time: '4:30 PM', date: '20-12-2025' },
              { matchNumber: 8, team1: 'Eos', team2: 'Apricus', time: '5:30 PM', date: '20-12-2025' },
              { matchNumber: 11, team1: 'Apollo', team2: 'Apricus', time: '6:30 PM', date: '20-12-2025' }
            ]
          },
          {
            groupName: 'Group C',
            matches: [
              { matchNumber: 4, team1: 'Kinesis', team2: 'Midas', time: '4:30 PM', date: '20-12-2025' },
              { matchNumber: 9, team1: 'Midas', team2: 'Aphrodite', time: '6:00 PM', date: '20-12-2025' },
              { matchNumber: 12, team1: 'Kinesis', team2: 'Aphrodite', time: '6:30 PM', date: '20-12-2025' }
            ]
          },
          {
            groupName: 'Group D',
            matches: [
              { matchNumber: 5, team1: 'Venus', team2: 'Asilo', time: '5:00 PM', date: '20-12-2025' },
              { matchNumber: 10, team1: 'Asilo', team2: 'Alexious', time: '6:00 PM', date: '20-12-2025' },
              { matchNumber: 13, team1: 'Venus', team2: 'Alexious', time: '7:00 PM', date: '20-12-2025' }
            ]
          }
        ],
        knockoutMatches: [
          { stage: 'Semi Final 1', match: 'Group A vs Group D', time: 'TBA', date: '20-12-2025', matchNumber: 14 },
          { stage: 'Semi Final 2', match: 'Group B vs Group C', time: 'TBA', date: '20-12-2025', matchNumber: 15 },
          { stage: 'Third Place', match: 'Loser SF1 vs Loser SF2', time: 'TBA', date: '20-12-2025', matchNumber: 16 },
          { stage: 'Finals', match: 'Winner SF1 vs Winner SF2', time: 'TBA', date: '20-12-2025', matchNumber: 17 }
        ]
      },
      'football': {
        sportName: 'Futsal',
        matchDate: '19-12-2025 & 20-12-2025',
        coordinator: 'Mr.Vansh Saluja - BNI Vulcan/ Mr.Yash Pathai BNI Midas',
        // sponsor: {
        //   name: 'Mr. Jeet Patel',
        //   company: "Nadiad Nexus",
        //   logo: nnLogo,
        //   chapter: 'BNI Kinesis'
        // },
        groups: [
          {
            groupName: 'Group A',
            color: '#e8d5fd',
            teams: [
              { position: 'A1', name: 'EOS' },
              { position: 'A2', name: 'Apricus' },
              { position: 'A3', name: 'Albus' },
              { position: 'A4', name: 'Venus' }
            ]
          },
          {
            groupName: 'Group B',
            color: '#d5c5f0',
            teams: [
              { position: 'B1', name: 'Apollo' },
              { position: 'B2', name: 'Asilo' },
              { position: 'B3', name: 'Vesta' }
            ]
          },
          {
            groupName: 'Group C',
            color: '#c9b3e6',
            teams: [
             { position: 'C1', name: 'Alexious' },
              { position: 'C2', name: 'Kinesis' },
              { position: 'C3', name: 'Midas' }
            ]
          },
          {
            groupName: 'Group D',
            color: '#b8a0db',
            teams: [
              { position: 'D1', name: 'Egan' },
              { position: 'D2', name: 'Aphrodite' },
              { position: 'D3', name: 'Vulcan' }
            ]
          }
        ],
        roundRobinMatches: [
          {
            groupName: 'Group A',
            matches: [
              { matchNumber: 1, team1: 'EOS', team2: 'Apricus', time: '6:00 PM', date: '19-12-2025' },
              { matchNumber: 2, team1: 'Albus', team2: 'Venus', time: '6:00 PM', date: '19-12-2025' },
              { matchNumber: 6, team1: 'EOS', team2: 'Albus', time: '9:00 AM', date: '20-12-2025' },
              { matchNumber: 10, team1: 'Apricus', team2: 'Venus', time: '10:30 AM', date: '20-12-2025' }
            ]
          },
          {
            groupName: 'Group B',
            matches: [
              { matchNumber: 3, team1: 'Apollo', team2: 'Asilo', time: '6:45 PM', date: '19-12-2025' },
              { matchNumber: 7, team1: 'Asilo', team2: 'Vesta', time: '9:00 AM', date: '20-12-2025' },
              { matchNumber: 11, team1: 'Apollo', team2: 'Vesta', time: '10:30 AM', date: '20-12-2025' }
            ]
          },
          {
            groupName: 'Group C',
            matches: [
              { matchNumber: 4, team1: 'Alexious', team2: 'Kinesis', time: '6:45 PM', date: '19-12-2025' },
              { matchNumber: 8, team1: 'Kinesis', team2: 'Midas', time: '9:45 AM', date: '20-12-2025' },
              { matchNumber: 12, team1: 'Alexious', team2: 'Midas', time: '11:15 AM', date: '20-12-2025' }
            ]
          },
          {
            groupName: 'Group D',
            matches: [
              { matchNumber: 5, team1: 'Egan', team2: 'Aphrodite', time: '7:30 PM', date: '19-12-2025' },
              { matchNumber: 9, team1: 'Aphrodite', team2: 'Vulcan', time: '9:45 AM', date: '20-12-2025' },
              { matchNumber: 13, team1: 'Egan', team2: 'Vulcan', time: '11:15 AM', date: '20-12-2025' }
            ]
          }
        ],
        knockoutMatches: [
          { stage: 'Semi Final 1', match: 'Group A vs Group D', time: 'TBA', date: '20-12-2025', matchNumber: 14 },
          { stage: 'Semi Final 2', match: 'Group B vs Group C', time: 'TBA', date: '20-12-2025', matchNumber: 15 },
          { stage: 'Third Place', match: 'Loser SF1 vs Loser SF2', time: 'TBA', date: '20-12-2025', matchNumber: 16 },
          { stage: 'Finals', match: 'Winner SF1 vs Winner SF2', time: 'TBA', date: '20-12-2025', matchNumber: 17 }
        ]
      },

      'volleyball': {
        sportName: 'Volleyball',
        matchDate: '20-12-2025',
        coordinator: 'Mr. Manish Malhotra - BNI Vesta/ Mr.Dharmendra Baradiya BNI EOS',
        // sponsor: {
        //   name: 'Mr. Jeet Patel',
        //   company: "Nadiad Nexus",
        //   logo: nnLogo,
        //   chapter: 'BNI Kinesis'
        // },
        groups: [
          {
            groupName: 'Group A',
            color: '#e8d5fd',
            teams: [
              { position: 'A1', name: 'Midas' },
              { position: 'A2', name: 'Asilo' },
              { position: 'A3', name: 'Alexious' },
              { position: 'A4', name: 'Aphrodite' }
            ]
          },
          {
            groupName: 'Group B',
            color: '#d5c5f0',
            teams: [
              { position: 'B1', name: 'Apricus' },
              { position: 'B2', name: 'Vulcan' },
              { position: 'B3', name: 'Vesta' }
            ]
          },
          {
            groupName: 'Group C',
            color: '#c9b3e6',
            teams: [
              { position: 'C1', name: 'Kinesis' },
              { position: 'C2', name: 'Egan' },
              { position: 'C3', name: 'Apollo' }
            ]
          },
          {
            groupName: 'Group D',
            color: '#b8a0db',
            teams: [
              { position: 'D1', name: 'Venus' },
              { position: 'D2', name: 'Albus' },
              { position: 'D3', name: 'EOS' }
            ]
          }
        ],
        roundRobinMatches: [
          {
            groupName: 'Group A',
            matches: [
              { matchNumber: 1, team1: 'Midas', team2: 'Asilo', time: '4:00 PM', date: '20-12-2025' },
              { matchNumber: 2, team1: 'Alexious', team2: 'Aphrodite', time: '4:30 PM', date: '20-12-2025' },
              { matchNumber: 6, team1: 'Midas', team2: 'Alexious', time: '6:30 PM', date: '20-12-2025' },
              { matchNumber: 7, team1: 'Asilo', team2: 'Aphrodite', time: '7:00 PM', date: '20-12-2025' }
            ]
          },
          {
            groupName: 'Group B',
            matches: [
              { matchNumber: 3, team1: 'Apricus', team2: 'Vulcan', time: '5:00 PM', date: '20-12-2025' },
              { matchNumber: 8, team1: 'Vulcan', team2: 'Vesta', time: '7:30 PM', date: '20-12-2025' },
              { matchNumber: 11, team1: 'Apricus', team2: 'Vesta', time: '9:00 PM', date: '20-12-2025' }
            ]
          },
          {
            groupName: 'Group C',
            matches: [
              { matchNumber: 4, team1: 'Kinesis', team2: 'Egan', time: '5:30 PM', date: '20-12-2025' },
              { matchNumber: 9, team1: 'Egan', team2: 'Apollo', time: '8:00 PM', date: '20-12-2025' },
              { matchNumber: 12, team1: 'Kinesis', team2: 'Apollo', time: '9:30 PM', date: '20-12-2025' }
            ]
          },
          {
            groupName: 'Group D',
            matches: [
              { matchNumber: 5, team1: 'Venus', team2: 'Albus', time: '6:00 PM', date: '20-12-2025' },
              { matchNumber: 10, team1: 'Albus', team2: 'EOS', time: '8:30 PM', date: '20-12-2025' },
              { matchNumber: 13, team1: 'Venus', team2: 'EOS', time: '10:00 PM', date: '20-12-2025' }
            ]
          }
        ],
        knockoutMatches: [
          { stage: 'Semi Final 1', match: 'Group A vs Group D', time: 'TBA', date: '20-12-2025', matchNumber: 14 },
          { stage: 'Semi Final 2', match: 'Group B vs Group C', time: 'TBA', date: '20-12-2025', matchNumber: 15 },
          { stage: 'Third Place', match: 'Loser SF1 vs Loser SF2', time: 'TBA', date: '20-12-2025', matchNumber: 16 },
          { stage: 'Finals', match: 'Winner SF1 vs Winner SF2', time: 'TBA', date: '20-12-2025', matchNumber: 17 }
        ]
      },

      'carrom': {
        sportName: 'Carrom',
        matchDate: '20-12-2025',
        coordinator: 'Mr. Manish Malhotra - BNI Vesta/ Mr.Dharmendra Baradiya BNI EOS',
        sponsor: {
          name: 'Mr. Pitamber Tahiliani',
          company: "Sai Financial Solution",
          logo: saiFinLogo,
          chapter: 'BNI Egan'
        },
        groups: [
          {
            groupName: 'Group A',
            color: '#e8d5fd',
            teams: [
              { position: 'A1', name: 'Aphrodite' },
              { position: 'A2', name: 'Asilo' },
              { position: 'A3', name: 'Kinesis' },
              { position: 'A4', name: 'Eos' }
            ]
          },
          {
            groupName: 'Group B',
            color: '#d5c5f0',
            teams: [
              { position: 'B1', name: 'Vulcan' },
              { position: 'B2', name: 'Apricus' },
              { position: 'B3', name: 'Alexious' }
            ]
          },
          {
            groupName: 'Group C',
            color: '#c9b3e6',
            teams: [
              { position: 'C1', name: 'Midas' },
              { position: 'C2', name: 'Vesta' },
              { position: 'C3', name: 'Albus' }
            ]
          },
          {
            groupName: 'Group D',
            color: '#b8a0db',
            teams: [
              { position: 'D1', name: 'Egan' },
              { position: 'D2', name: 'venus' },
              { position: 'D3', name: 'Apollo' }
            ]
          }
        ],
        roundRobinMatches: [
          {
            groupName: 'Group A',
            matches: [
              { matchNumber: 1, team1: 'Aphrodite', team2: 'Asilo', time: '12:00 PM', date: '20-12-2025' },
              { matchNumber: 2, team1: 'Kinesis', team2: 'Eos', time: '12:00 PM', date: '20-12-2025' },
              { matchNumber: 6, team1: 'Aphrodite', team2: 'Kinesis', time: '1:00 PM', date: '20-12-2025' },
              { matchNumber: 7, team1: 'Asilo', team2: 'Eos', time: '1:30 PM', date: '20-12-2025' }
            ]
          },
          {
            groupName: 'Group B',
            matches: [
              { matchNumber: 3, team1: 'Vulcan', team2: 'Apricus', time: '12:30 PM', date: '20-12-2025' },
              { matchNumber: 8, team1: 'Apricus', team2: 'Alexious', time: '1:30 PM', date: '20-12-2025' },
              { matchNumber: 11, team1: 'Vulcan', team2: 'Alexious', time: '2:30 PM', date: '20-12-2025' }
            ]
          },
          {
            groupName: 'Group C',
            matches: [
              { matchNumber: 4, team1: 'Midas', team2: 'Vesta', time: '12:30 PM', date: '20-12-2025' },
              { matchNumber: 9, team1: 'Vesta', team2: 'Albus', time: '2:00 PM', date: '20-12-2025' },
              { matchNumber: 12, team1: 'Midas', team2: 'Albus', time: '2:30 PM', date: '20-12-2025' }
            ]
          },
          {
            groupName: 'Group D',
            matches: [
              { matchNumber: 5, team1: 'Egan', team2: 'Venus', time: '1:00 PM', date: '20-12-2025' },
              { matchNumber: 10, team1: 'Venus', team2: 'Apollo', time: '2:00 PM', date: '20-12-2025' },
              { matchNumber: 13, team1: 'Egan', team2: 'Apollo', time: '3:00 PM', date: '20-12-2025' }
            ]
          }
        ]
      },

      'table-tennis': {
        sportName: 'Table Tennis',
        matchDate: '21-12-2025',
        coordinator: 'Mr.Niraj Soni - BNI Apricus/ Dr. Mittal Parmar BNI Albus',
        // sponsor: {
        //   name: 'Mr. Pitamber Tahiliani',
        //   company: "Sai Financial Solution",
        //   logo: saiFinLogo,
        //   chapter: 'BNI Egan'
        // },
       groups: [
          {
            groupName: 'Group A',
            color: '#e8d5fd',
            teams: [
              { position: 'A1', name: 'Venus' },
              { position: 'A2', name: 'Alexious' },
              { position: 'A3', name: 'Apricus' },
              { position: 'A4', name: 'Vulcan' }
            ]
          },
          {
            groupName: 'Group B',
            color: '#d5c5f0',
            teams: [
              { position: 'B1', name: 'Midas' },
              { position: 'B2', name: 'Kinesis' },
              { position: 'B3', name: 'Eos' }
            ]
          },
          {
            groupName: 'Group C',
            color: '#c9b3e6',
            teams: [
              { position: 'C1', name: 'Albus' },
              { position: 'C2', name: 'Aphrodite' },
              { position: 'C3', name: 'Apollo' }
            ]
          },
          {
            groupName: 'Group D',
            color: '#b8a0db',
            teams: [
              { position: 'D1', name: 'Vesta' },
              { position: 'D2', name: 'Asilo' },
              { position: 'D3', name: 'Egan' }
            ]
          }
        ],
        roundRobinMatches: [
          {
            groupName: 'Group A',
            matches: [
              { matchNumber: 1, team1: 'Venus', team2: 'Alexious', time: '9:00 AM', date: '21-12-2025' },
              { matchNumber: 2, team1: 'Apricus', team2: 'Vulcan', time: '9:00 AM', date: '21-12-2025' },
              { matchNumber: 6, team1: 'Venus', team2: 'Apricus', time: '10:00 AM', date: '21-12-2025' },
              { matchNumber: 7, team1: 'Alexious', team2: 'Vulcan', time: '10:30 AM', date: '21-12-2025' }
            ]
          },
          {
            groupName: 'Group B',
            matches: [
              { matchNumber: 3, team1: 'Midas', team2: 'Kinesis', time: '9:30 AM', date: '21-12-2025' },
              { matchNumber: 8, team1: 'Kinesis', team2: 'Eos', time: '10:30 AM', date: '21-12-2025' },
              { matchNumber: 11, team1: 'Midas', team2: 'Eos', time: '11:30 AM', date: '21-12-2025' }
            ]
          },
          {
            groupName: 'Group C',
            matches: [
              { matchNumber: 4, team1: 'Albus', team2: 'Aphrodite', time: '9:30 AM', date: '21-12-2025' },
              { matchNumber: 9, team1: 'Aphrodite', team2: 'Apollo', time: '11:00 AM', date: '21-12-2025' },
              { matchNumber: 12, team1: 'Albus', team2: 'Apollo', time: '11:30 AM', date: '21-12-2025' }
            ]
          },
          {
            groupName: 'Group D',
            matches: [
              { matchNumber: 5, team1: 'Vesta', team2: 'Asilo', time: '10:00 AM', date: '21-12-2025' },
              { matchNumber: 10, team1: 'Asilo', team2: 'Egan', time: '11:00 AM', date: '21-12-2025' },
              { matchNumber: 13, team1: 'Vesta', team2: 'Egan', time: '12:00 PM', date: '21-12-2025' }
            ]
          }
        ],
        knockoutMatches: [
          { stage: 'Semi Final 1', match: 'Group A vs Group D', time: '3:30 PM', date: '21-12-2025', matchNumber: 14 },
          { stage: 'Semi Final 2', match: 'Group B vs Group C', time: '4:00 PM', date: '21-12-2025', matchNumber: 15 },
          { stage: 'Third Place', match: 'Loser SF1 vs Loser SF2', time: '5:00 PM', date: '21-12-2025', matchNumber: 16 },
          { stage: 'Finals', match: 'Winner SF1 vs Winner SF2', time: '5:30 PM', date: '21-12-2025', matchNumber: 17 }
        ]
      },

      'croquet': {
        sportName: 'Croquet',
        matchDate: '20-12-2025',
        coordinator: 'Mr.Ashish Gandhi - BNI Venus/ Mr.Harshyam Patel BNI Venus',
        // sponsor: {
        //   name: 'Mr. Pitamber Tahiliani',
        //   company: "Sai Financial Solution",
        //   logo: saiFinLogo,
        //   chapter: 'BNI Egan'
        // },
        groups: [
          {
            groupName: 'Group A',
            color: '#e8d5fd',
            teams: [
              { position: 'A1', name: 'Midas' },
              { position: 'A2', name: 'Vulcan' },
              { position: 'A3', name: 'Eos' },
              { position: 'A4', name: 'Egan' }
            ]
          },
          {
            groupName: 'Group B',
            color: '#d5c5f0',
            teams: [
              { position: 'B1', name: 'Venus' },
              { position: 'B2', name: 'Aphrodite' },
              { position: 'B3', name: 'Vesta' }
            ]
          },
          {
            groupName: 'Group C',
            color: '#c9b3e6',
            teams: [
              { position: 'C1', name: 'Apollo' },
              { position: 'C2', name: 'Apricus' },
              { position: 'C3', name: 'Kinesis' }
            ]
          },
          {
            groupName: 'Group D',
            color: '#b8a0db',
            teams: [
              { position: 'D1', name: 'Alexious' },
              { position: 'D2', name: 'Albus' },
              { position: 'D3', name: 'Asilo' }
            ]
          }
        ],
        roundRobinMatches: [
          {
            groupName: 'Group A',
            matches: [
              { matchNumber: 1, team1: 'Midas', team2: 'Vulcan', time: '4:00 PM', date: '20-12-2025' },
              { matchNumber: 2, team1: 'Eos', team2: 'Egan', time: '4:30 PM', date: '20-12-2025' },
              { matchNumber: 6, team1: 'Midas', team2: 'Eos', time: '6:30 PM', date: '20-12-2025' },
              { matchNumber: 7, team1: 'Vulcan', team2: 'Egan', time: '7:00 PM', date: '20-12-2025' }
            ]
          },
          {
            groupName: 'Group B',
            matches: [
              { matchNumber: 3, team1: 'Venus', team2: 'Aphrodite', time: '5:00 PM', date: '20-12-2025' },
              { matchNumber: 8, team1: 'Aphrodite', team2: 'Vesta', time: '7:00 PM', date: '20-12-2025' },
              { matchNumber: 11, team1: 'Venus', team2: 'Vesta', time: '9:00 PM', date: '20-12-2025' }
            ]
          },
          {
            groupName: 'Group C',
            matches: [
              { matchNumber: 4, team1: 'Apollo', team2: 'Apricus', time: '5:30 PM', date: '20-12-2025' },
              { matchNumber: 9, team1: 'Apricus', team2: 'Kinesis', time: '8:00 PM', date: '20-12-2025' },
              { matchNumber: 12, team1: 'Apollo', team2: 'Kinesis', time: '9:30 PM', date: '20-12-2025' }
            ]
          },
          {
            groupName: 'Group D',
            matches: [
              { matchNumber: 5, team1: 'Alexious', team2: 'Albus', time: '6:00 PM', date: '20-12-2025' },
              { matchNumber: 10, team1: 'Albus', team2: 'Asilo', time: '8:30 PM', date: '20-12-2025' },
              { matchNumber: 13, team1: 'Alexious', team2: 'Asilo', time: '10:00 PM', date: '20-12-2025' }
            ]
          }
        ]
      },

      'pickleball': {
        sportName: 'Pickleball',
        matchDate: '19-12-2025',
        coordinator: 'Mr.Rakesh Trivedi - BNI Midas/ Mr.Vedant bafna BNI EOS',
        // sponsor: {
        //   name: 'Mr. Pitamber Tahiliani',
        //   company: "Sai Financial Solution",
        //   logo: saiFinLogo,
        //   chapter: 'BNI Egan'
        // },
       groups: [
          {
            groupName: 'Group A',
            color: '#e8d5fd',
            teams: [
              { position: 'A1', name: 'Asilo' },
              { position: 'A2', name: 'Midas' },
              { position: 'A3', name: 'Vulcan' },
              { position: 'A4', name: 'Vesta' }
            ]
          },
          {
            groupName: 'Group B',
            color: '#d5c5f0',
            teams: [
              { position: 'B1', name: 'Alexious' },
              { position: 'B2', name: 'Kinesis' },
              { position: 'B3', name: 'EOS' }
            ]
          },
          {
            groupName: 'Group C',
            color: '#c9b3e6',
            teams: [
              { position: 'C1', name: 'Apricus' },
              { position: 'C2', name: 'Albus' },
              { position: 'C3', name: 'Apollo' }
            ]
          },
          {
            groupName: 'Group D',
            color: '#b8a0db',
            teams: [
              { position: 'D1', name: 'Venus' },
              { position: 'D2', name: 'Aphrodite' },
              { position: 'D3', name: 'Egan' }
            ]
          }
        ],
        roundRobinMatches: [
          
          {
            groupName: 'Group A',
            matches: [
              { matchNumber: 1, team1: 'Asilo', team2: 'Midas', time: '6:00 PM', date: '19-12-2025' },
              { matchNumber: 2, team1: 'Vulcan', team2: 'Vesta', time: '6:00 PM', date: '19-12-2025' },
              { matchNumber: 5, team1: 'Asilo', team2: 'Vulcan', time: '7:00 PM', date: '19-12-2025' },
              { matchNumber: 6, team1: 'Midas', team2: 'Vesta', time: '7:00 PM', date: '19-12-2025' }
            ]
          },
          {
            groupName: 'Group B',
            matches: [
              { matchNumber: 3, team1: 'Alexious', team2: 'Kinesis', time: '6:30 PM', date: '19-12-2025' },
              { matchNumber: 7, team1: 'Kinesis', team2: 'EOS', time: '7:30 PM', date: '19-12-2025' },
              { matchNumber: 12, team1: 'Alexious', team2: 'EOS', time: '9:30 PM', date: '19-12-2025' }
            ]
          },
          {
            groupName: 'Group C',
            matches: [
              { matchNumber: 4, team1: 'Apricus', team2: 'Albus', time: '6:30 PM', date: '19-12-2025' },
              { matchNumber: 8, team1: 'Albus', team2: 'Apollo', time: '7:30 PM', date: '19-12-2025' },
              { matchNumber: 10, team1: 'Apricus', team2: 'Apollo', time: '8:30 PM', date: '19-12-2025' }
            ]
          },
          {
            groupName: 'Group D',
            matches: [
              { matchNumber: 9, team1: 'Venus', team2: 'Aphrodite', time: '8:00 PM', date: '19-12-2025' },
              { matchNumber: 11, team1: 'Aphrodite', team2: 'Egan', time: '9:00 PM', date: '19-12-2025' },
              { matchNumber: 13, team1: 'Venus', team2: 'Egan', time: '10:00 PM', date: '19-12-2025' }
            ]
          }
        ]
      },

      'satodiyu': {
        sportName: 'Satodiyu',
        matchDate: '21-12-2025',
        coordinator: 'Mr.Shashank Soni - BNI Kinesis/ Mr.Dharmesh Kunadia BNI Albus',
        // sponsor: {
        //   name: 'Mr. Pitamber Tahiliani',
        //   company: "Sai Financial Solution",
        //   logo: saiFinLogo,
        //   chapter: 'BNI Egan'
        // },
       groups: [
          {
            groupName: 'Group A',
            color: '#e8d5fd',
            teams: [
              { position: 'A1', name: 'Albus' },
              { position: 'A2', name: 'Vesta' },
              { position: 'A3', name: 'Apollo' },
              { position: 'A4', name: 'Aphrodite' }
            ]
          },
          {
            groupName: 'Group B',
            color: '#d5c5f0',
            teams: [
              { position: 'B1', name: 'Vulcan' },
              { position: 'B2', name: 'Kinesis' },
              { position: 'B3', name: 'Asilo' }
            ]
          },
          {
            groupName: 'Group C',
            color: '#c9b3e6',
            teams: [
              { position: 'C1', name: 'EOS' },
              { position: 'C2', name: 'Egan' },
              { position: 'C3', name: 'Alexious' }
            ]
          },
          {
            groupName: 'Group D',
            color: '#b8a0db',
            teams: [
              { position: 'D1', name: 'Venus' },
              { position: 'D2', name: 'Midas' },
              { position: 'D3', name: 'Apricus' }
            ]
          }
        ],
        roundRobinMatches: [
          {
            groupName: 'Group A',
            matches: [
              { matchNumber: 1, team1: 'Albus', team2: 'Vesta', time: '9:00 AM', date: '21-12-2025' },
              { matchNumber: 2, team1: 'Apollo', team2: 'Aphrodite', time: '9:00 AM', date: '21-12-2025' },
              { matchNumber: 6, team1: 'Albus', team2: 'Apollo', time: '10:00 AM', date: '21-12-2025' },
              { matchNumber: 7, team1: 'Vesta', team2: 'Aphrodite', time: '10:30 AM', date: '21-12-2025' }
            ]
          },
          {
            groupName: 'Group B',
            matches: [
              { matchNumber: 3, team1: 'Vulcan', team2: 'Kinesis', time: '9:30 AM', date: '21-12-2025' },
              { matchNumber: 8, team1: 'Kinesis', team2: 'Asilo', time: '10:30 AM', date: '21-12-2025' },
              { matchNumber: 11, team1: 'Vulcan', team2: 'Asilo', time: '11:30 AM', date: '21-12-2025' }
            ]
          },
          {
            groupName: 'Group C',
            matches: [
              { matchNumber: 4, team1: 'Eos', team2: 'Egan', time: '9:30 AM', date: '21-12-2025' },
              { matchNumber: 9, team1: 'Egan', team2: 'Alexious', time: '11:00 AM', date: '21-12-2025' },
              { matchNumber: 12, team1: 'Eos', team2: 'Alexious', time: '11:30 AM', date: '21-12-2025' }
            ]
          },
          {
            groupName: 'Group D',
            matches: [
              { matchNumber: 5, team1: 'Venus', team2: 'Midas', time: '10:00 AM', date: '21-12-2025' },
              { matchNumber: 10, team1: 'Midas', team2: 'Apricus', time: '11:00 AM', date: '21-12-2025' },
              { matchNumber: 13, team1: 'Venus', team2: 'Apricus', time: '12:00 AM', date: '21-12-2025' }
            ]
          }
        ],
        knockoutMatches: [
          { stage: 'Semi Final 1', match: 'Group A vs Group D', time: '3:30 PM', date: '21-12-2025', matchNumber: 14 },
          { stage: 'Semi Final 2', match: 'Group B vs Group C', time: '4:00 PM', date: '21-12-2025', matchNumber: 15 },
          { stage: 'Third Place', match: 'Loser SF1 vs Loser SF2', time: '5:00 PM', date: '21-12-2025', matchNumber: 16 },
          { stage: 'Finals', match: 'Winner SF1 vs Winner SF2', time: '5:30 PM', date: '21-12-2025', matchNumber: 17 }
        ]
      },
      
      

      // Add other sports data here...
    };

    return sportDataMap[sportIdParam] || sportDataMap['badminton'];
  };

  useEffect(() => {
    fetchTournamentDraws();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tournamentId, sportId]);

  const fetchTournamentDraws = async () => {
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem('token') || localStorage.getItem('Token');

      if (!token) {
        console.log('No token found, using fallback data');
      }

      await new Promise(resolve => setTimeout(resolve, 500));
      
      const sportData = getSportData(sportId);
      
      setTournament({ name: 'Bishop Games 6.0' });
      setSport({ 
        name: sportData.sportName, 
        matchDate: sportData.matchDate,
        coordinator: sportData.coordinator,
        sponsor: sportData.sponsor
      });
      setGroups(sportData.groups);
      setRoundRobinMatches(sportData.roundRobinMatches);

      setLoading(false);
    } catch (err) {
      console.error('Error fetching tournament draws:', err);
      setError(err.message);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="tournament-draws-container">
        <div className="loading-state">
          <div className="spinner-border text-primary" role="status"></div>
          <p className="mt-3">Loading tournament draws...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="tournament-draws-container">
        <div className="error-state">
          <i className="fas fa-exclamation-circle fa-3x text-danger mb-3"></i>
          <h4>Error Loading Draws</h4>
          <p>{error}</p>
          <button className="btn btn-primary" onClick={() => navigate(-1)}>
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="tournament-draws-container">
      {/* ✅ FINAL LAYOUT: Back Button + Content + Bishop Logo + Sponsor */}
      <div className="draws-header">
        {/* ✅ Back Button - Top Left Corner */}
        <button className="back-btn" onClick={() => navigate(`/tournament-sports/${tournamentId}`)}>
          <i className="fas fa-arrow-left me-2"></i>
          Back to Sports
        </button>

        {/* ✅ Main Content Area with 3 sections */}
        <div className="header-main-content">
          {/* ✅ LEFT: Title Information (Left-Aligned, Multi-line) */}
          <div className="header-left-content">
            <h1 className="draws-title">
              <i className="fas fa-trophy me-2"></i>
              {sport?.name || 'Sport'} - Tournament Draws
            </h1>
            <p className="draws-subtitle">{tournament?.name || 'Tournament'}</p>
            {sport?.matchDate && sport.matchDate !== 'TBA' && (
              <p className="match-date-info">
                <i className="fas fa-calendar-day me-2"></i>
                Match Date: {sport.matchDate}
              </p>
            )}
            {sport?.coordinator && (
              <p className="coordinator-info">
                <i className="fas fa-user-tie me-2"></i>
                Game Coordinator: {sport.coordinator}
              </p>
            )}
          </div>

          {/* ✅ CENTER: Bishop Games Logo */}
          <div className="header-center-content">
            <img 
              src={bishopGamesLogo} 
              alt="Bishop Games Season 6" 
              className="tournament-logo"
            />
          </div>

          {/* ✅ RIGHT: Sponsor Card */}
          <div className="header-right-content">
            {sport?.sponsor && (
              <div className="game-sponsor-container">
                <div className="sponsor-badge">
                  <span className="sponsor-label">Game Sponsor</span>
                </div>
                {sport.sponsor.logo && (
                  <div className="sponsor-logo-wrapper">
                    <img 
                      src={sport.sponsor.logo} 
                      alt={sport.sponsor.company}
                      className="sponsor-logo"
                    />
                  </div>
                )}
                <div className="sponsor-info">
                  <p className="sponsor-company">{sport.sponsor.company}</p>
                  <p className="sponsor-name">{sport.sponsor.name}</p>
                  {sport.sponsor.chapter && (
                    <p className="sponsor-chapter">{sport.sponsor.chapter}</p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* View Tabs */}
      <div className="view-tabs">
        <button
          className={`tab-btn ${activeView === 'groups' ? 'active' : ''}`}
          onClick={() => setActiveView('groups')}
        >
          <i className="fas fa-users me-2"></i>
          Groups
        </button>
        <button
          className={`tab-btn ${activeView === 'matches' ? 'active' : ''}`}
          onClick={() => setActiveView('matches')}
        >
          <i className="fas fa-calendar-alt me-2"></i>
          Round Robin Matches
        </button>
      </div>

      {/* Groups View */}
      {activeView === 'groups' && (
        <div className="groups-section">
          <h2 className="section-title">
            <i className="fas fa-layer-group me-2"></i>
            Tournament Groups
          </h2>
          <div className="groups-grid">
            {groups.map((group, index) => (
              <div key={index} className="group-card">
                <div 
                  className="group-header"
                  style={{ background: `linear-gradient(135deg, ${group.color} 0%, ${group.color}dd 100%)` }}
                >
                  <h3>{group.groupName}</h3>
                </div>
                <div className="group-body">
                  <table className="group-table">
                    <thead>
                      <tr>
                        <th>Position</th>
                        <th>Team</th>
                      </tr>
                    </thead>
                    <tbody>
                      {group.teams.map((team, teamIndex) => (
                        <tr key={teamIndex}>
                          <td className="position-cell">
                            <span className="position-badge">{team.position}</span>
                          </td>
                          <td className="team-cell">{team.name}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Round Robin Matches View */}
      {activeView === 'matches' && (
        <div className="matches-section">
          <h2 className="section-title">
            <i className="fas fa-calendar-check me-2"></i>
            Round Robin Match Schedule
          </h2>
          
          {roundRobinMatches.map((groupMatches, groupIndex) => (
            <div key={groupIndex} className="round-robin-group">
              <div className="round-robin-header">
                <h3>
                  <i className="fas fa-circle-notch me-2"></i>
                  {groupMatches.groupName} - Round Robin
                </h3>
              </div>
              
              <div className="matches-table-container">
                <table className="round-robin-table">
                  <thead>
                    <tr>
                      <th className="match-number-col">Match</th>
                      <th className="team-col">Team 1</th>
                      <th className="vs-col">vs</th>
                      <th className="team-col">Team 2</th>
                      <th className="time-col">Time</th>
                      <th className="date-col">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {groupMatches.matches.map((match, matchIndex) => (
                      <tr key={matchIndex}>
                        <td className="match-number-cell">
                          <span className="match-badge">Match {match.matchNumber}</span>
                        </td>
                        <td className="team-name">{match.team1}</td>
                        <td className="vs-cell">
                          <span className="vs-badge">VS</span>
                        </td>
                        <td className="team-name">{match.team2}</td>
                        <td className="time-cell">
                          <i className="fas fa-clock me-1"></i>
                          {match.time}
                        </td>
                        <td className="date-cell">
                          <i className="fas fa-calendar me-1"></i>
                          {match.date}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TournamentDraws;